import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PropTypes from 'prop-types';
import { clearStoredRedirectForAudience, getStoredRedirectForAudience } from '../utils/authStorage';

const PublicRoute = ({ children }) => {
    const { user } = useAuth();

    if (user) {
        const postLoginRedirect = getStoredRedirectForAudience();
        if (postLoginRedirect && user.role !== 'parent') {
            clearStoredRedirectForAudience();
            return <Navigate to={postLoginRedirect} replace />;
        }
        // 如果已登入，根據角色導向對應的儀表板
        if (user.role === 'parent') {
            return <Navigate to="/parent/dashboard" replace />;
        }
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

PublicRoute.propTypes = {
    children: PropTypes.node.isRequired
};

export default PublicRoute;
